<template>
   <body>
    <div class="myPost_wrapper">
      <!-- title -->
      <div class="main_top">
        <h1><img src ="images/basic/icon/back.svg" onclick="history.back()" class="back">
          주문내역
        </h1>
        <div class="h1_div">
          <img src="images/basic/icon/couponbox.svg" alt="">
        </div>
      </div>
      <div class="div_padding"></div>
      <!-- list -->
      <div class="list_div">
        <div class="product">
          <div class="img">
            <img :src="product_img" />
          </div>
          <div class="product_info">
            <div class="bold">{{product_name}}</div>
            <div class="bold"><span>{{product_price}}</span> FUS x {{product_qt}} </div>
            <div class="option">2021.08.21 오후 03:21</div>
          </div>
        </div>
        <div class="product">
          <div class="img">
            <img :src="product_img" />
          </div>
          <div class="product_info">
            <div class="bold">{{product_name}}</div>
            <div class="bold"><span>{{product_price}}</span> FUS x {{product_qt}} </div>
            <div class="option">2021.08.21 오후 03:21</div>
          </div>
        </div>
        <div class="product">
          <div class="img">
            <img :src="product_img" />
          </div>
          <div class="product_info">
            <div class="bold">{{product_name}}</div>
            <div class="bold"><span>{{product_price}}</span> FUS x {{product_qt}} </div>
            <div class="option">2021.08.21 오후 03:21</div>
          </div>
        </div>
        <div class="product cancel">
          <div class="img">
            <img :src="product_img" />
          </div>
          <div class="product_info">
            <div class="bold">{{product_name}}</div>
            <div class="bold"><span>{{product_price}}</span> FUS x {{product_qt}} </div>
            <div class="option">2021.08.21 오후 03:21</div>
          </div>
        </div>
      </div>
    </div>
  </body>  
</template>
<script>
export default {
  data() {
    return {
      phone: '010 7786 9872',
      fus: '2,400.05',
      product_img: "images/basic/img/shopping-item4.png",
      product_name: '스타벅스 아메리카노 커플 세트',
      product_option: '없음',
      option: {
          color: '#6F737A',
          'font-weight': 'normal',
        },
      product_price: '5.9',
      product_qt: '1',
      price: '5.9',
    }
  },
}
</script>

<style>

</style>